import { render, staticRenderFns } from "./nothingLoaded.vue?vue&type=template&id=7bb944a9&scoped=true&"
import script from "./nothingLoaded.vue?vue&type=script&lang=js&"
export * from "./nothingLoaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb944a9",
  null
  
)

export default component.exports